import * as React from "react";
import type { SVGProps } from "react";
const SvgZapOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#zap-off_svg__a)">
      <path
        fill="currentColor"
        d="M11.418 6.627a1 1 0 0 0 1.984.246zM13 2l.992.123a1 1 0 0 0-1.76-.763zM9.801 4.28a1 1 0 1 0 1.538 1.28zm8.001 7.989a1 1 0 0 0 1.536 1.282zM21 10l.768.641A1 1 0 0 0 21 9zm-5.34-1a1 1 0 1 0 0 2zm-6.892-.36a1 1 0 1 0-1.536-1.28zM3 14l-.768-.64A1 1 0 0 0 3 15zm9 0 .992.124A1 1 0 0 0 12 13zm-1 8-.992-.124a1 1 0 0 0 1.76.764zm5.768-5.36a1 1 0 1 0-1.536-1.28zM1.708.293A1 1 0 0 0 .292 1.707zm20.585 23.414a1 1 0 0 0 1.414-1.414zm-8.89-16.834.59-4.75-1.985-.246-.59 4.75zM12.23 1.36l-2.43 2.92 1.538 1.28 2.43-2.92zm7.107 12.191 2.43-2.91-1.536-1.282-2.43 2.91zM21 9h-5.34v2H21zM7.232 7.36l-5 6 1.536 1.28 5-6zM3 15h9v-2H3zm8.008-1.124-1 8 1.984.248 1-8zm.76 8.764 5-6-1.536-1.28-5 6zM.293 1.707l22 22 1.414-1.414-22-22z"
      />
    </g>
    <defs>
      <clipPath id="zap-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgZapOff;
